import React, { useRef } from 'react';
import { observer } from 'mobx-react';
import stores from 'cd-eft/models/Stores';
import { PointTranslationByCoordinatesVM } from './PointTranslationByCoordinatesVM';
import { SelectPointOnMapButton } from '../PointTranslationSelectPointButton';

const setStore = stores.AppStore.surveyEngineeringStore;

// second Option
export const PointCoordinates = observer((props) => {
  const vm = useRef(new PointTranslationByCoordinatesVM(props)).current;

  setStore.deltaX = setStore.transTargetX - setStore.transRefX;
  setStore.deltaY = setStore.transTargetY - setStore.transRefY;
  setStore.deltaZ = setStore.transTargetZ - setStore.transRefZ;

  return (
    <div className="translation-option-2">
      <div className="point-translation-header">
        <h5>Translate all points in XY and/or Z by identifying matching points</h5>
      </div>
      <div className="translate-region">
        <div>
          <h5>Translate</h5>
        </div>
        <div className="form-row-fixed-height">
          <div className="col col-md-3 display-flex">
            <label className="usa-label">Ref. Pt </label>
            <input
              type="text"
              className="usa-input"
              id="ref-pt"
              value={setStore.transRefName}
              onChange={vm.onChangeHandler}
              disabled
            />
            <SelectPointOnMapButton pointType="transRef" setFormError={props.setFormError} />
          </div>
          <div className="col col-md-3 display-flex">
            <label className="usa-label">&nbsp;&nbsp;X </label>
            <input type="number" className="usa-input" id="ref-pt-x" value={setStore.transRefX} disabled />
          </div>
          <div className="col col-md-3 display-flex">
            <label className="usa-label">&nbsp;&nbsp;Y </label>
            <input type="number" className="usa-input" id="ref-pt-y" value={setStore.transRefY} disabled />
          </div>
          <div className="col col-md-3 display-flex">
            <label className="usa-label">&nbsp;&nbsp;Z </label>
            <input type="number" className="usa-input" id="ref-pt-z" value={setStore.transRefZ} disabled />
          </div>
        </div>
        <div className="form-row-fixed-height">
          <div className="col col-md-3 display-flex">
            <label className="usa-label">Target Pt</label>
            <input
              type="text"
              className="usa-input"
              id="target-pt"
              value={setStore.transTargetName}
              onChange={vm.onChangeHandler}
              disabled
            />
          </div>
          <div className="col col-md-3 display-flex">
            <label className="usa-label">&nbsp;&nbsp;X </label>
            <input type="number" className="usa-input" id="target-pt-x" value={setStore.transTargetX} disabled />
          </div>
          <div className="col col-md-3 display-flex">
            <label className="usa-label">&nbsp;&nbsp;Y </label>
            <input type="number" className="usa-input" id="target-pt-y" value={setStore.transTargetY} disabled />
          </div>
          <div className="col col-md-3 display-flex">
            <label className="usa-label">&nbsp;&nbsp;Z </label>
            <input type="number" className="usa-input" id="target-pt-z" value={setStore.transTargetZ} disabled />
          </div>
        </div>
      </div>
      <div className="results-region">
        <div>
          <h5>Results</h5>
        </div>
        <div className="form-row-fixed-height justify-content-end">
          <div className="col-md-auto my-2">Translate Values:</div>
          <div className="col col-md-3 display-flex">
            <label className="usa-label">&Delta;X </label>
            <input
              type="number"
              className="usa-input"
              id="results-delta-x"
              placeholder="0.00"
              value={Number.parseFloat(setStore.deltaX.toFixed(3))}
              disabled
            />
          </div>
          <div className="col col-md-3 display-flex">
            <label className="usa-label">&Delta;Y </label>
            <input
              type="number"
              className="usa-input"
              id="results-delta-y"
              placeholder="0.00"
              value={Number.parseFloat(setStore.deltaY.toFixed(3))}
              disabled
            />
          </div>
          <div className="col col-md-3 display-flex">
            <label className="usa-label">&Delta;Z </label>
            <input
              type="number"
              className="usa-input"
              id="results-delta-z"
              placeholder="0.00"
              value={Number.parseFloat(setStore.deltaZ.toFixed(3))}
              disabled
            />
          </div>
        </div>
      </div>
    </div>
  );
});
